/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DaysOfWeekMask } from './daysOfWeekMask';
import { PricingType } from './pricingType';
import { RateType } from './rateType';


export interface CreateLocationRateDto { 
    locationId?: number;
    rateType?: RateType;
    hour?: number;
    untilTimeOfDay?: string | null;
    nextDayShiftThreshold?: string | null;
    rate?: number;
    displayName: string;
    displayOrder?: number;
    isActive?: boolean;
    startDateTime?: string | null;
    endDateTime?: string | null;
    expiryTimeOfDay?: string | null;
    sameDayExpiry?: boolean;
    validFromTimeOfDay?: string | null;
    validToTimeOfDay?: string | null;
    availableDays?: DaysOfWeekMask;
    taxType?: PricingType;
    tax?: number | null;
    serviceFeeType?: PricingType;
    serviceFee?: number | null;
}
export namespace CreateLocationRateDto {
}


